
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions",
      function () {
        return require("private-next-pages/terms-and-conditions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-and-conditions"])
      });
    }
  